import type { UserDetailResponse } from '../api/generated';

// Falls back to the email so a user with an empty name is still identifiable in
// a rights grid or an error message, rather than showing as a blank row.
export const getUserDisplayName = (user: UserDetailResponse): string =>
  `${user.firstName} ${user.lastName}`.trim() || user.email;
